import { ThemeOptions } from "@mui/material/styles";

export const cardOverrides: ThemeOptions["components"] = {
	MuiCard: {
		styleOverrides: {
			root: ({ theme }) => ({
				backgroundColor: theme.palette.common.white,
				borderRadius: theme.spacing(2),
				boxShadow: "0 2px 8px 0 rgba(0, 87, 178, 0.10)",
			}),
		},
	},
};
